module.exports = __webpack_public_path__ + "img/2.4f60a779.png";